import { StyleSheet, useWindowDimensions, View } from 'react-native'
import { BREAKPOINTS } from '@/lib/config'
import { formatHoursReadable } from '@/lib/dates'
import { StatCard } from './StatCard'

const GAP = 8

interface StatCardRowProps {
    totalHours: number
    totalEntries: number
    activeUsers: number
    avgHoursPerUser: number
    hoursChangePercent: number
}

export function StatCardRow({
    totalHours,
    totalEntries,
    activeUsers,
    avgHoursPerUser,
    hoursChangePercent,
}: StatCardRowProps) {
    const { width } = useWindowDimensions()
    const isMobile = width < BREAKPOINTS.md

    if (isMobile) {
        return (
            <View style={styles.gridMobile}>
                <View style={styles.mobileRow}>
                    <StatCard
                        label="Total Hours"
                        value={formatHoursReadable(totalHours)}
                        changePercent={hoursChangePercent}
                    />
                    <StatCard label="Total Entries" value={String(totalEntries)} />
                </View>
                <View style={styles.mobileRow}>
                    <StatCard label="Team Members" value={String(activeUsers)} />
                    <StatCard label="Avg Hrs/Person" value={formatHoursReadable(avgHoursPerUser)} />
                </View>
            </View>
        )
    }

    return (
        <View style={styles.gridDesktop}>
            <StatCard
                label="Total Hours"
                value={formatHoursReadable(totalHours)}
                changePercent={hoursChangePercent}
            />
            <StatCard label="Total Entries" value={String(totalEntries)} />
            <StatCard label="Team Members" value={String(activeUsers)} />
            <StatCard label="Avg Hours/Person" value={formatHoursReadable(avgHoursPerUser)} />
        </View>
    )
}

const styles = StyleSheet.create({
    gridMobile: {
        gap: GAP,
    },
    mobileRow: {
        flexDirection: 'row',
        gap: GAP,
    },
    gridDesktop: {
        flexDirection: 'row',
        gap: GAP,
    },
})
